import { AxiosResponse } from 'axios';
import { api } from './base/api';
import { IScreensApi } from './base/screensApi';
import { MenuResponse } from '../models/response';
import { Result } from '../models/common/resultResponse';

const baseRoute: string = 'Screen';

export class ScreensApi extends IScreensApi {
  getScreens(): Promise<AxiosResponse<Result<MenuResponse[]>>> {
    return api.get(`${baseRoute}/allowedScreens`);
  }
}

